import { FileLogger } from "./file.logger";

/**
 * Creates a logger with today's date as filename
 */
class DailyLogger extends FileLogger {
	constructor(prefix: string, normalDebug: boolean, fileLocation: string) {
		const fileName = (new Date()).toISOString().split("T")[0];
		super(fileName, prefix, normalDebug, fileLocation);
	}
}

/**
 * Function that returns a logger to specified folder, and filename equal to today's date in yyyy-mm-dd format
 * @param {string} prefix prefix for all logs to start with
 * @param {boolean} normalDebug wether to write logs using normal debug module as well as file
 * @param {string} fileLocation log file location insied ./log
 * @returns {DailyLogger}
 */
export const dailyLogger = (prefix: string, normalDebug = false, fileLocation: string = FileLogger.DEFAULT_RELATIVE_FILE_LOCATION): DailyLogger => new DailyLogger(prefix, normalDebug, fileLocation);